var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#DB0025"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.5C13.1716 20.5 12.5 21.1716 12.5 22C12.5 22.8284 13.1716 23.5 14 23.5L14 20.5ZM32.0607 23.0607C32.6464 22.4749 32.6464 21.5251 32.0607 20.9393L22.5147 11.3934C21.9289 10.8076 20.9792 10.8076 20.3934 11.3934C19.8076 11.9792 19.8076 12.9289 20.3934 13.5147L28.8787 22L20.3934 30.4853C19.8076 31.0711 19.8076 32.0208 20.3934 32.6066C20.9792 33.1924 21.9289 33.1924 22.5147 32.6066L32.0607 23.0607ZM14 23.5L31 23.5L31 20.5L14 20.5L14 23.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.69f4e52f9fbca949a8ef6e3330245075.svg";
export { ForwardRef as ReactComponent };